export default __webpack_public_path__ + "assets/tuto3.jpg";